import Table from "./table";
import React from "react";
import ContextMenu from "../context_menu";
import { If } from "react-extras";
import isEmpty from "lodash/isEmpty";

const additionalStyle = () => ({
  style: { overflow: "visible" },
});
const tBodyAdditionalStyle = () => ({ style: { overflow: "visible", minHeight: "64px" } });
const tdAdditionalStyle = () => ({
  style: {
    overflow: "visible",
    padding: "0",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
});

export const StyledTable = props => (
  <Table
    getTdProps={tdAdditionalStyle}
    getTbodyProps={tBodyAdditionalStyle}
    getTableProps={additionalStyle}
    noDataText={""}
    getTheadProps={() => ({
      style: {
        display: "none",
      },
    })}
    {...props}
  />
);

export const TwoLineCell = ({ title, subtitle }) => (
  <div className={"two-line-table-row"}>
    <div className="title">{title}</div>
    <div className="subtitle">{subtitle}</div>
  </div>
);

export const TwoLineTableRow = ({ title, subtitle, onClick, menuItems }) => (
  <div className="flex-row-container align-center pointer " onClick={() => onClick && onClick()}>
    <TwoLineCell title={title} subtitle={subtitle} />
    <div className="flex-1" />
    <If condition={!isEmpty(menuItems)}>
      <div
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
        }}>
        <ContextMenu noCircle={true} menuItems={menuItems} />
      </div>
    </If>
  </div>
);
